import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from '../../context';
import Users from './Users';
import PolicyAcknowledgements from './PolicyAcknowledgments';
import DTBs from './DTBs';
import { REPORTING_NAV_ITEMS } from './navItems';
import InsightsCenter from './InsightsCenter';
import FeaturesManager from 'utils/features/FeaturesManager';

FeaturesManager.registerFeature({
  id: 'policy_insights_center',
  name: 'Policy Insights Center',
  description: 'Enable Policy Insights Center',
  enabled: false,
  maxEnv: 'prod',
});

export default function Reporting() {
  const {
    hasPermission,
    enforcePermissions,
    setCurrentModule,
    currentOrganizationId,
    registerNavItems,
    isFeatureEnabled,
  } = useContext(AppContext);

  const getDefaultRoute = () => {
    const hasTrainingAccess = hasPermission('accessTrainingInsightsCenter', currentOrganizationId || '');
    const hasPolicyAccess = hasPermission('accessPolicyInsightsCenter', currentOrganizationId || '');
    const policyFlagEnabled = isFeatureEnabled('policy_insights_center');

    if (hasTrainingAccess || (hasPolicyAccess && policyFlagEnabled)) {
      return <Navigate to='./insights-center' />;
    } else if (hasPermission('reportUserList', currentOrganizationId)) {
      return <Navigate to='./users' />;
    } else if (hasPermission('listPolicyAcknowledgementReports', currentOrganizationId)) {
      return <Navigate to='./policy-acknowledgments' />;
    } else if (hasPermission('getDtbReport', currentOrganizationId)) {
      return <Navigate to='./dtbs' />;
    } else {
      return <Navigate to='/dashboard' />;
    }
  };

  useEffect(() => {
    setCurrentModule('reporting');
    registerNavItems('reporting', REPORTING_NAV_ITEMS);
  }, [setCurrentModule, registerNavItems]);

  return (
    <Routes>
      <Route
        path=''
        element={getDefaultRoute()}
      />
      <Route
        path='users/*'
        element={enforcePermissions(['reportUserList'], <Users />)}
      />
      <Route
        path='policy-acknowledgments/*'
        element={enforcePermissions(['listPolicyAcknowledgementReports'], <PolicyAcknowledgements />)}
      />
      <Route
        path='dtbs/*'
        element={enforcePermissions(['getDtbReport'], <DTBs />)}
      />
      <Route
        path='insights-center/*'
        element={<InsightsCenter />}
      />
    </Routes>
  );
}
